import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { resendEmailVerification } from "../../../redux/slices/authSlice";

import background from "../../../assets/images/heroVerify.svg";
import icon from "../../../assets/icons/emailVerify.svg";

const Container = styled.div`
  background: url(${background}) no-repeat;
  background-size: cover;
  height: 100vh;
  //overflow-y: hidden;
  padding: 200px 500px;

  @media screen and (max-width: 820px) {
    padding: 100px 20px;
  }
`;
const Card = styled.div`
  margin: auto;
  margin-top: 5%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 50px 20px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
  background-color: #fff;
  h3 {
    margin-top: 20px;
  }
  p {
    margin: 20px 0px;
  }
  .buttons {
    display: flex;
    margin-top: 20px;
    gap: 10px;
    .go-back,
    .resend {
      padding: 10px 16px;
      height: 40px;
      border: 1px solid #d0d5dd;
      border-radius: 8px;
      font-size: 14px;
      background-color: transparent;
      text-decoration: none;
      cursor: pointer;
      a {
        text-decoration: none;
        color: #344054;
      }
    }
    .resend {
        color: #fff;
      border: 1px solid #03a9f4;
      background-color: #03a9f4;
    }
  }
`;

const Verification = () => {
  const dispatch = useDispatch();
  const { email } = useParams();

  const {loading} = useSelector((state) => state.auth)
  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(resendEmailVerification(email));
  };

  return (
    <Container>
      <Card>
        <img src={icon} alt="icon" />
        <h3>Email Verification</h3>
        <p>
          Almost there! We’ve sent a verification link to {email} you
          need to verify your email before you can continue
        </p>
        <div className="buttons">
          <button className="resend" type="submit" disabled={loading} onClick={handleSubmit}>
            {loading ? 'Resending...' : 'Resend'}
          </button>
        </div>
      </Card>
    </Container>
  );
};

export default Verification;
